import {CoinsBannerSection_CoinsInfoSheet} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {FONT_SIZES, tabletAndUpLinaria, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {CoinsFeatureInfos} from '../../../../features/Coins/CoinsWallet/CoinsWalletContent/CoinsFeatureInfos';

export const CoinsBannerPopupInfoSheet: React.FC<
  Pick<
    CoinsBannerSection_CoinsInfoSheet,
    'headline' | 'infoText' | 'featureInfos'
  >
> = ({headline, infoText, featureInfos}) => {
  return (
    <Wrapper>
      <Text size="px24" weight="w700" textAlignment="center">
        {headline}
      </Text>
      <StyledCoinsFeatureInfos featureInfos={featureInfos} />
      <InfoText
        size="px10"
        weight="w400"
        color="Text.Grey"
        textAlignment="center"
      >
        {infoText}
      </InfoText>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  width: 100%;
  height: 100%;
`;

const StyledCoinsFeatureInfos = styled(CoinsFeatureInfos)`
  padding-inline: 16px;
`;

const InfoText = styled(Text)`
  padding-inline: 16px;
  font-size: ${FONT_SIZES.px10};

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px14};
    line-height: 1.4;
  `)}
`;
